import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ZoningCode } from 'src/app/modules/instance/models';
import { InstanceService, ZoningCodeService } from 'src/app/modules/instance/services';
import { ZcIndexingProcessSettingsDialogComponent } from '../../../dialogs/zc-indexing-process-settings-dialog/zc-indexing-process-settings-dialog.component';
import { filter } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-zoning-code-index-button',
    templateUrl: './zoning-code-index-button.component.html',
    styleUrls: ['./zoning-code-index-button.component.scss']
})
export class ZoningCodeIndexButtonComponent {
    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        private readonly instanceService: InstanceService,
        protected readonly dialog: MatDialog
    ) {}

    @Input()
    zoningCode: ZoningCode;

    openIndexZCPropertyRecordsTaskDialog(event: Event, zoningCode: ZoningCode, offset?: number) {
        event.stopPropagation();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.data = this.zoningCode;
        dialogConfig.maxHeight = '850px';
        dialogConfig.width = '650px';
        dialogConfig.disableClose = true;

        this.dialog
            .open(ZcIndexingProcessSettingsDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(filter(isConfirm => isConfirm))
            .subscribe(indexingTaskPrams => {
                if (!indexingTaskPrams) {
                    return;
                }
                this.zoningCodeService.indexZCPropertyRecords({
                    ...indexingTaskPrams,
                    instance: this.instanceService.selectedInstance,
                    zoningCodeId: zoningCode.Id,
                    zcGridicsId: zoningCode.GridicsId,
                    offset
                });
            });
    }
}
